var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.progressDisplay)?_c('div',{staticClass:"text-center pageLoadingProgress"},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-progress-circular',{attrs:{"size":100,"color":"primary","indeterminate":"","width":5}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }